// /src/hooks/useInitializeKnowledgeTestState.js

import { useEffect } from 'react';
import { useProfileQuery } from 'src/modules/myProfile/src/profileQueries';
import { useKnowledgeTestDispatch } from '../contexts/KnowledgeTestContext';

export const useInitializeKnowledgeTestState = () => {
    const { data: profileData } = useProfileQuery();
    const dispatch = useKnowledgeTestDispatch();

    useEffect(() => {
        if (profileData) {
            const isKnowledgeTestPassed = profileData.knowledge_test_check;

            if (isKnowledgeTestPassed) {
                dispatch({ type: 'setPassKnowledgeTest' });
                dispatch({ type: 'closeKnowledgeTestModal' });
            } else {
                dispatch({ type: 'setFailKnowledgeTest' });

                if (!sessionStorage.getItem('has_shown_knowledge_test_modal')) {
                    dispatch({ type: 'viewKnowledgeTestModal' });
                }
            }
        }
    }, [profileData, dispatch]);
};
